<template>
  <div class="header-bg">
    <div class="bg">
      <div class="select-box-bg">
      <div class="logo" @click="pushLogin">
        <img src="@/assets/logo.svg" alt="logo" />
      </div>

      <div class="header-scroll">
      <!-- <div class="dashboard-box" v-show="isShow">
        <el-button class="select-btn" @click="pushDashboard">Dashboard</el-button>
      </div> -->
      <div class="select-box1" v-show="isShow">
        <el-dropdown class="dropdown" trigger="click" @command="selectBenchMarkCommand">
          <el-button class="select-btn">
            {{ curBenchMark }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(select, index) in benchMarkList"
                class="dropdown-item"
                :command="index"
                :key="index"
                :disabled="select.disabled"
                :style="{color: getCurrentColor(select.routePath)}"
                >{{ select.title }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>  

      <!-- isShow -->
      <div class="select-box" v-show="false">
        <el-dropdown class="dropdown" trigger="click" @command="selectDevOpCommand">
          <el-button class="select-btn">
            {{ curDevOp }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(select, index) in devOpList"
                class="dropdown-item"
                :command="index"
                :key="index"
                :disabled="select.disabled"
                >{{ select.title }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>  

      <div class="select-box" v-show="isShow">
        <el-dropdown class="dropdown" trigger="click" @command="selectIcbUnivCommand" :disabled="true">
          <el-button class="select-btn" :style="{color: '#565656'}" @click="pushRfc">
            {{ curRFC }}<i class="el-icon-arrow-down el-icon--right" v-show="false"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(select, index) in icbUnivList"
                class="dropdown-item"
                :command="index"
                :key="index"
                :disabled="select.disabled"
                >{{ select.title }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div> 
      
      <div class="select-box" v-show="showCost">
        <el-button class="select-btn" @click="pushCost">COST</el-button>
      </div>  

      <div class="select-box" v-show="isShow">
        <el-dropdown trigger="click" @command="selectMetricsCommand">
          <el-button class="select-btn">
            {{ metricsData.curTitle }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="model in metricsData.list"
                class="dropdown-item"
                :command="model"
                :key="model"
                :style="{color: metricColor(model)}"
                >{{ model.title }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>  


      <div class="select-box" v-show="isShow">
        <el-dropdown trigger="click" @command="selectServiseCommand" :disabled="true">
          <el-button class="select-btn" :style="{color: '#b4b4b4'}">
            {{ curServise }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(select, index) in serviseList"
                class="dropdown-item"
                :command="index"
                :key="index"
                :disabled="select.disabled"
                >{{ select.title }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>  

      <div class="select-box" v-show="isShow">
        <el-dropdown trigger="click" @command="selectIdentityCommand" :disabled="true">
          <el-button class="select-btn" :style="{color: '#b4b4b4'}">
            {{ curIdentity }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(select, index) in identityList"
                class="dropdown-item"
                :command="index"
                :key="index"
                :disabled="select.disabled"
                >{{ select.title }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
      </div>
      <div v-if="isShow" class="right">
        <el-dropdown trigger="click" @command="selectRightCommand">
          <div class="user-box">
            <div class="name">{{ fullName }}</div>
            <img src="@/assets/icon-user.png" class="icon" alt="" />
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(str, index) in rightlist"
                class="dropdown-item"
                :command="index"
                :key="index"
                >{{ str }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserById } from "@/request/api";
import { clearAllStorage } from "@/utils/Setitem"
import { BenchMarkType, MetricType } from "@/utils/common"
const FULL_NAME = "FULL_NAME"
export default {
  name: "header-bg",
  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    page: {
      type: String,
      default: ""
    }
  },
  watch: {
    isShow(val) {
      this.isShowIcon = val;
    },

    $route(to, from) {
      if (to.fullPath != from.fullPath) {
        this.locationPath = window.location.pathname
      }
    },
  },
  data() {
    return {
      locationPath: window.location.pathname,
      isShowIcon: this.isShow,
      fullName: "",
      show: false,
      curBenchMark: "Benchmark",
      benchMarkList: [
        {
          title: "Data",
          disabled: false,
          page: "List",
          routePath: BenchMarkType.Data
        },
        {
          title: "Trial",
          disabled: false,
          page: "List",
          routePath: BenchMarkType.Trial
        },
        {
          title: "Sheet",
          disabled: false,
          page: "List",
          routePath: BenchMarkType.Sheet
        },
        {
          title: "Tigris",
          disabled: false,
          page: "List",
          routePath: BenchMarkType.Tigris
        },
      ],
      curDevOp: "DevOps",
      devOpList: [
        {
          title: "Benchmark",
          disabled: false,
          page: "NewBenchMark"
        },
        {
          title: "Regression",
          disabled: false,
          page: "regressionPage"
        },
        {
          title: "Coverage",
          disabled: false,
          page: "coveragePage"
        },
        {
          title: "Release",
          disabled: true,
          page: ""
        }
      ],
      curRFC: "RFC",
      metricsData: {
        curTitle: 'CodeQuality',
        list: [
          {
            title: this.$DataString.metricTags[0],
            path: MetricType.Issue
          },
          {
            title: "CodeCoverage",
            path: MetricType.Coverage
          },
          {
            title: this.$DataString.metricTags[2],
            path: MetricType.Warning
          },
          {
            title: this.$DataString.metricTags[1],
            path: MetricType.Assertion
          },  
        ],
      },
      icbUnivList: [
        {
          title: "Training",
          disabled: true,
        },
        {
          title: "Grow",
          disabled: true,
        },
        {
          title: "Communication",
          disabled: true,
        },
        {
          title: "Knowledge",
          disabled: true,
        }
      ],
      curServise: "Servise",
      serviseList: [
        {
          title: "LEC",
          disabled: true,
        },
        {
          title: "DRC",
          disabled: true,
        },
      ],
      curIdentity: "Identity",
      identityList: [
        {
          title: "Admin",
          disabled: true,
        },
        {
          title: "AE",
          disabled: true,
        },
      ],
      rightlist: ["Sign out"],
      //"Personal Center",
    };
  },

  computed: {
    showCost() {
      const isHave = this.$DataString?.whiteList?.some(name => {
        return this.fullName.toLocaleLowerCase() == name?.toLocaleLowerCase()
      })
      return isHave && this.isShow
    },
    metricColor() {
      return (model => {
        const pathName = this.locationPath.toLocaleLowerCase()
        const page = model?.path.toLocaleLowerCase()
        if (pathName.includes(page)) {
          return '#3894ff'
        }
        return '#565656'
      })
    },
    showMetric() {
      const isHave = this.$DataString?.metricWhiteList?.some(name => {
        return this.fullName.toLocaleLowerCase() == name?.toLocaleLowerCase()
      })
      return isHave && this.isShow
    }
  },
  methods: {
    pushDashboard() {
      const token = localStorage.getItem("token");
      this.$cookies.set("token", token);
      const locatStr = window.location.origin;
      window.open(`${locatStr}/benchmark/dashboard`, "_blank")
    },
    selectMetricsCommand(model) {
      if (model.path == MetricType.Upload) {
        this.$router.replace({name: "MetricUploadPage"})
      } else if (model.path == MetricType.Coverage) {
        this.$router.replace({name: "CodeCoveragePage"})
      } else {
        this.$router.replace({name: "MetricsPage", params: {pageName: model.path}})
      }
    },
    pushCost() {
      this.$router.push({name: 'UserCostListPage'})
    },
    getCurrentColor(title) {
      return this.page.toLocaleLowerCase() == title.toLocaleLowerCase() ? '#3894ff' : '#565656'
    },
    selectBenchMarkCommand(index) {
      const model = this.benchMarkList[index]
      this.$store.commit("updateBenchmark", model.title.toLocaleLowerCase())
      this.$router.replace({ name: model.page, params: { index: model.routePath.toLocaleLowerCase()}})
    },
    selectDevOpCommand(index) {
      console.log(index);
      const model = this.devOpList[index]
      this.curDevOp = model.title
      // if (index == 0) {
      this.$router.push({ path: `/devops/${model.page}`})
      // }
    },
    selectIcbUnivCommand(index) {
      console.log(index);
      this.curRFC = this.icbUnivList[index].title
    },
    pushRfc() {
      const token = localStorage.getItem("token");
      this.$cookies.set("token", token);
      const locatStr = window.location.origin;
      window.open(`${locatStr}/rfcserver/ICBench/RFC/master/`, "_blank")
    },
    selectServiseCommand(index) {
      console.log(index);
      this.curServise = this.serviseList[index].title
    },
    selectIdentityCommand(index) {
      console.log(index);
      this.curIdentity = this.identityList[index].title
    },
    selectRightCommand(index) {
      console.log(index);
      this.quit();
    },
    pushLogin() {
      this.$router.replace({ name: "Home"})
    },

    quit() {
      this.$confirm("Do you want to sign out?", "Notice", {
        confirmButtonText: "Sign Out",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          clearAllStorage(); //清除所有key 
          this.$cookies.remove("token")
          this.$router.push({ name: "Login" });
          this.$message({
            type: "success",
            message: "sign out success!",
          });
          window.localStorage.clear(); //清除所有key 
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消",
          // });
        });
    },
  },
  async created() {
    if (this.isShowIcon) {
      if (!sessionStorage.getItem(FULL_NAME)) {
        const userInfo = await getUserById();
        this.fullName = userInfo.user?.nickname;
        sessionStorage.setItem(FULL_NAME, this.fullName)
        console.log("userInfo = ", userInfo);
      } else {
        this.fullName = sessionStorage.getItem(FULL_NAME)
      }
    }
    this.locationPath = window.location.pathname
    const isHave = this.$DataString?.metricWhiteList?.some(name => {
      return this.fullName.toLocaleLowerCase() == name?.toLocaleLowerCase()
    })
    if (isHave) {
      this.metricsData.list.push({ title: "Upload", path: MetricType.Upload })
    }
  },
};
</script>
<style lang='less' scoped>
.header-bg {
  height: 102px;
  width: 100%;
  background-color: #fff;
  justify-content: center;
  display: flex;
  border-style: none none solid none;
  border-width: 0.25px;
  border-color: #f6f6f6;
  .bg {
    width: 100%; //90vw;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
  }

  .header-scroll {
    margin-left: 100px;
    display: flex;
    width: calc(100vw - 600px);
    height: 100%;
    overflow-x:auto;
    overflow-y:hidden;
  }

  //滚动条里的小方块
  .header-scroll::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #f5f5f5;
  }

  //滚动条整体样式
  .header-scroll::-webkit-scrollbar {
    width: 5px;
    height: 3px;  //高宽分别对应横竖滚动条的尺寸
  }
  //滚动条中心部分
  .header-scroll::-webkit-scrollbar-track {
    background-color: #fff;
  }


  .select-box-bg {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .logo {
    width: 211px;
    height: 30px;
    // margin-left: -10px;
    align-items: left;
    margin-left: 83px;
  }

  .dashboard-box {
    margin-right: 30px;
  }

  .select-box1 {
    margin-left: 0px;
  }

  .select-box {
    margin-left: 30px;
  }

  .select-btn {
    border-width: 0px;
    // margin-left: 60px;
  }

  .select-btn:hover {
    background-color: #f9f9f9;
    border-width: 1px;
  }

  .right {
    display: flex;
    align-items: center;
    margin-right: 30px;
    .user-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
    }
    .name {
      margin-right: 20px;
      color: #0050b3;
      font-size: 20px;
    }
    .icon {
      width: 30px;
      height: 30px;
    }
  }
}

.select-btn {
  min-width: 80px;
}

:deep(.el-dropdown-menu__item) {
  min-width: 90px !important;
  justify-content: center !important;
}
</style>